import { useLayoutEffect, useRef } from 'react';

const useHoverPosition = ({
  containerRef,
  onHover,
  onHoverEnd,
  onHoverStart
}) => {
  const refDefault = useRef({});

  const ref = containerRef || refDefault;

  const currentRef = ref.current || refDefault.current;

  useLayoutEffect(() => {
    const handleMousemove =
      onHover &&
      (e => {
        const rect = currentRef.getBoundingClientRect();
        onHover({
          x: e.clientX - rect.left,
          y: e.clientY - rect.top
        });
      });

    if (currentRef.addEventListener) {
      onHover && currentRef.addEventListener('mousemove', handleMousemove);
      onHoverEnd && currentRef.addEventListener('mouseout', onHoverEnd);
      onHoverStart && currentRef.addEventListener('mouseover', onHoverStart);
    }

    return function cleanUpListeners() {
      if (currentRef.removeEventListener) {
        onHover && currentRef.removeEventListener('mousemove', handleMousemove);
        onHoverEnd && currentRef.removeEventListener('mouseout', onHoverEnd);
        onHoverStart &&
          currentRef.removeEventListener('mouseover', onHoverStart);
      }
    };
  }, [currentRef, onHover, onHoverEnd, onHoverStart]);
};

export default useHoverPosition;
